import React, {useState, useEffect, useRef} from 'react';
import {findEnabledCustomersByQueryString} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";

const apiUrl = Config.apiUrl;
const SaleManagerCustomer = () => {
        const [customers, setCustomers] = useState([]);
        const [filteredCustomers, setFilteredCustomers] = useState([]);
        const [queryString, setQueryString] = useState('');
        const inputQueryString = useRef(null);
        const [, setLoading] = useRecoilState(loadingAtom);
        const navigate = useNavigate();
        const sale = JSON.parse(localStorage.getItem('sale'));

        function removeSpecialChars(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        }

        async function makeQuery(query) {
            try {
                setLoading(true);
                const customers = await findEnabledCustomersByQueryString(query);
                // Ordenar alfabeticamente por nome
                const sortedCustomers = customers.sort((a, b) => {
                    const nameA = removeSpecialChars(a.name).toUpperCase();
                    const nameB = removeSpecialChars(b.name).toUpperCase();
                    return nameA.localeCompare(nameB);
                });
                setCustomers(sortedCustomers);
                setFilteredCustomers(sortedCustomers);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        }

        useEffect(() => {
            if (inputQueryString.current) {
                inputQueryString.current.focus();
            }
            makeQuery('');
        }, []);

        const handleInputChange = (e) => {
            const string = removeSpecialChars(e.target.value).toUpperCase();
            const filtered = customers.filter((f) => removeSpecialChars(f.name).toUpperCase().includes(string));
            // Manter ordenação alfabética após filtrar
            const sortedFiltered = filtered.sort((a, b) => {
                const nameA = removeSpecialChars(a.name).toUpperCase();
                const nameB = removeSpecialChars(b.name).toUpperCase();
                return nameA.localeCompare(nameB);
            });
            setFilteredCustomers(sortedFiltered);
            setQueryString(string);
        };

        return (
            <>
                <div className="header-label">Comanda</div>

                <div
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                    className="input-container">
                    <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                           onChange={handleInputChange} onFocus={(event) => event.target.select()} inputMode="numeric"/>
                    <button id="clearButton" onClick={() => {
                        setQueryString('');
                        inputQueryString.current.focus();
                    }}>X
                    </button>
                </div>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '300px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>
                            Nome
                        </th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {filteredCustomers.map((customer, index) => (
                        <tr key={index}>
                            <td>
                                <div key={index}>{customer.name}</div>
                            </td>
                            <td>
                                <button onClick={async () => {
                                    const newSale = {table: sale.table, customer: customer, orderType: sale.orderType};
                                    localStorage.setItem('sale', JSON.stringify(newSale));
                                    navigate("/sale/items");
                                }}>Selecionar
                                </button>
                            </td>

                        </tr>
                    ))}
                    </tbody>
                    {customers.length === 0 &&
                        <tfoot>
                        <tr>
                            <td colSpan={5}>
                                Nenhum item encontrado
                            </td>
                        </tr>
                        </tfoot>
                    }
                </table>
            </>
        );
    }
;

export default SaleManagerCustomer;
